import { render, staticRenderFns } from "./VideoTest.vue?vue&type=template&id=00ad3dea"
import script from "./VideoTest.vue?vue&type=script&lang=js"
export * from "./VideoTest.vue?vue&type=script&lang=js"
import style0 from "./VideoTest.vue?vue&type=style&index=0&id=00ad3dea&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports